import GenericAlertModal from "./AlertModal";
export default GenericAlertModal;
